'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getForegroundColor = exports.getForegroundColor = function getForegroundColor(background, foreground) {
  var lightVariants = ['transparent', 'white', '#ffffff', '#fff'];

  var isBackgroundLight = !background || lightVariants.indexOf(background.toLowerCase()) !== -1;

  var isForegroundLight = !foreground || lightVariants.indexOf(foreground.toLowerCase()) !== -1;

  if (isBackgroundLight && isForegroundLight) {
    return '#000000';
  } else {
    return foreground;
  }
};